import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { GraduationCap, Star, LogOut, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const StarAuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-950 ptg-grid-bg p-4" data-testid="star-auth-shell">
    <div className="w-full max-w-md rounded-3xl bg-white p-8 sm:p-10 shadow-2xl">
      <Link to="/" className="flex items-center gap-3 mb-8">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-900 text-white"><GraduationCap className="h-7 w-7" /></div>
        <div>
          <div className="font-heading text-xl font-extrabold text-slate-900">PTG Star System</div>
          <div className="text-xs font-semibold text-sky-700 uppercase tracking-widest">Est. 2003</div>
        </div>
      </Link>
      <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><Star className="h-5 w-5 text-amber-500" /> {title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      {children}
    </div>
  </div>
);

export const StarDashLayout = ({ title, children, testid, headerGradient = false, hero = null }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-100" data-testid={testid}>
      <header className={headerGradient ? "bg-gradient-to-r from-slate-950 via-blue-950 to-indigo-900 text-white shadow-lg shadow-blue-950/20" : "bg-slate-950 text-white"}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-800 text-white"><Star className="h-5 w-5 text-amber-400" /></div>
            <div>
              <div className="font-heading font-extrabold leading-tight">{title}</div>
              <div className="text-[10px] text-sky-400 uppercase tracking-widest">PTG Star System</div>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            <a href="/" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-slate-300 hover:text-white px-3 py-2"><ExternalLink className="h-4 w-4" /> Website</a>
            <Button onClick={() => { logout(); navigate("/"); }} variant="ghost" className="text-red-300 hover:text-red-200 hover:bg-slate-800" data-testid="star-logout-btn"><LogOut className="h-4 w-4 mr-1.5" /> Logout</Button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        {hero ? hero : (
          <p className="text-sm text-slate-500 mb-6">Signed in as <span className="font-semibold text-slate-700">{user?.name || user?.email}</span>{user?.roll_number ? ` · Roll ${user.roll_number}` : ""}</p>
        )}
        {children}
      </main>
    </div>
  );
};
